import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import toast from 'react-hot-toast'

import AddFile from '../../../images/Add image.svg'

interface PropsDropzone {
  setUploadedFiles: React.Dispatch<React.SetStateAction<Blob | string>>
}

export const Dropzone = ({ setUploadedFiles }: PropsDropzone) => {
  const onDrop = useCallback((acceptedFiles: any) => {
    acceptedFiles.forEach((file: any) => {
      if (
        file.type !== 'text/csv' &&
        file.type !==
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
        file.type !== 'application/vnd.ms-excel'
      ) {
        return toast.error('Formato de arquivo não perimitido')
      }

      const reader = new FileReader()
      reader.onload = () => {
        reader.result
      }
      reader.readAsArrayBuffer(file)
    })
  }, [])

  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({ onDrop })

  const files = acceptedFiles.map((file: any) => {
    if (
      file.type !== 'text/csv' &&
      file.type !==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
      file.type !== 'application/vnd.ms-excel'
    ) {
      return
    }

    setUploadedFiles(file)
    return (
      <li
        className="text-[#4F46E5] list-none flex items-center gap-2 mt-1"
        key={file.name}
      >
        {`${file.path} - ${file.size} bytes`}
      </li>
    )
  })

  return (
    <>
      <section className="border-2 border-dashed border-gray-500 h-60 w-full p-8 text-center whitespace-nowrap text-[#4F46E5] text-2xl font-medium">
        <div
          {...getRootProps({
            className: 'flex flex-col items-center',
          })}
        >
          <input {...getInputProps()} />
          <div className="flex flex-col items-center cursor-pointer">
            <img
              src={AddFile}
              alt="Imagem de adição de arquivo"
              className="object-cover object-center w-[80px] h-[80px]"
            />
            <span className="text-[#4F46E5] text-md">Upload do arquivo</span>
            <span className="text-gray-500 text-[20px]">xlsx ou csv</span>
          </div>
        </div>
      </section>

      <ul>{files}</ul>
    </>
  )
}
